import { useWindowSize } from 'src/shared/hooks/use-window-size'

const PublicUserCardSkeleton = () => {
  const { width } = useWindowSize()

  if (width < 768) {
    // Mobile skeleton - just white background with profile photo and rating
    return (
      <div
        className="flex w-full min-w-[280px] rounded-[25px] border-[0.5px] border-border bg-white"
        style={{ boxShadow: '0px 1px 12px 1px rgba(27, 48, 41, 0.06)' }}
      >
        <div className="flex w-full flex-row items-center gap-3">
          {/* Profile photo skeleton */}
          <div className="relative flex flex-row">
            <div className="size-[100px] animate-pulse rounded-[25px] bg-gray-200" />
            {/* Rating badge skeleton */}
            <div className="absolute bottom-1.5 left-1/2 flex -translate-x-1/2 flex-row items-center justify-center gap-1 rounded-[6px] bg-primary px-1.5 py-1">
              <div className="h-3 w-4 animate-pulse rounded bg-white/20" />
              <div className="size-[10px] animate-pulse rounded-full bg-white/20" />
            </div>
          </div>

          {/* Text content skeleton */}
          <div className="flex w-full flex-col gap-2 py-3">
            {/* Name skeleton */}
            <div className="h-6 w-32 animate-pulse rounded bg-gray-200" />
            {/* Profession skeleton */}
            <div className="h-4 w-24 animate-pulse rounded bg-gray-200" />
            {/* Location skeleton */}
            <div className="flex items-center gap-1">
              <div className="size-[19px] animate-pulse rounded bg-gray-200" />
              <div className="h-3 w-20 animate-pulse rounded bg-gray-200" />
            </div>
          </div>
        </div>
      </div>
    )
  }

  // Desktop skeleton - white background with image and rating badge
  return (
    <div className="border-primary/10 group relative flex size-full flex-col justify-between rounded-[25px] border shadow-[2px_2px_10px_0px_rgba(25,58,45,0.10)]">
      <div>
        {/* Image skeleton */}
        <div className="relative aspect-[30/26] w-full overflow-hidden rounded-[25px]">
          <div className="absolute inset-0 size-full animate-pulse bg-gray-200" />
          {/* Rating badge skeleton */}
          <div className="absolute bottom-1.5 left-1/2 flex -translate-x-1/2 flex-row items-center justify-center gap-1 rounded-[6px] bg-primary px-1.5 py-1 md:bottom-auto md:left-3.5 md:top-3.5 md:translate-x-0 md:px-2.5 md:py-1.5">
            <div className="h-4 w-6 animate-pulse rounded bg-white/20 md:h-5 md:w-8" />
            <div className="size-[10px] animate-pulse rounded-full bg-white/20 md:size-[14px]" />
          </div>
        </div>

        {/* Text content skeleton */}
        <div className="p-5 text-center">
          {/* Name skeleton */}
          <div className="mb-3">
            <div className="mx-auto h-8 w-40 animate-pulse rounded bg-gray-200" />
          </div>

          {/* Profession skeleton */}
          <div className="mb-3">
            <div className="mx-auto h-5 w-32 animate-pulse rounded bg-gray-200" />
          </div>

          {/* Location skeleton */}
          <div className="flex items-center justify-center gap-1">
            <div className="size-[19px] animate-pulse rounded bg-gray-200" />
            <div className="h-4 w-20 animate-pulse rounded bg-gray-200" />
          </div>
        </div>
      </div>

      {/* Button skeleton */}
      <div className="p-5 pt-0">
        <div className="h-[50px] w-full animate-pulse rounded-full bg-gray-200" />
      </div>
    </div>
  )
}

export default PublicUserCardSkeleton
